export default "__VITE_PUBLIC_ASSET__f767d225__"